import { IQuickShareMarkAsSentParams } from 'lib/api/quickshare/useQuickShareMarkAsSentMutation';
import { NewModal } from 'lib/components';
import { useAuth } from 'lib/context';
import * as React from 'react';
import { Button } from 'react-covideo-common';
import { AiFillInfoCircle } from 'react-icons/ai';
import { useHistory } from 'react-router';
import styled, { useTheme } from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { getSecondaryColor } from 'lib/context/theme/utils';

const Text = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => getSecondaryColor(theme)};
`;

const ButtonsWrapper = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  gap: 10px;
`;

const BlueBox = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px 16px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.neutral[10]};
`;

const Disclaimer = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const DisclaimerIconWrap = styled.section`
  margin-right: 14px;
  height: 100%;
`;

type Props = {
  handleModalClose: () => void;
  quickShareMarkAsSentHandler: (params: IQuickShareMarkAsSentParams) => void;
  isQuickShareLoading?: boolean;
  markAsSentPayload: Omit<IQuickShareMarkAsSentParams, 'markAsSentConfirmed'>;
};

export const ModalQuickShareMarkAsSent = ({
  handleModalClose,
  quickShareMarkAsSentHandler,
  isQuickShareLoading,
  markAsSentPayload,
}: Props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { userData } = useAuth();
  const { isCompanyAdmin } = userData;

  const goToCompanySettings = () => {
    history.push(`/profile/Profile_EditCompanyInfo`);
  };
  return (
    <NewModal
      headerText={t("Mark Video as 'Sent'?")}
      closeModal={handleModalClose}
      style={{
        content: {
          width: '532px',
          minWidth: '532px',
        },
      }}
    >
      <BlueBox>
        <DisclaimerIconWrap>
          <AiFillInfoCircle size={24} color={colors.secondary[40]} />
        </DisclaimerIconWrap>
        <Disclaimer>
          <Text>
            {t(
              "If you don't want to answer this question with each quickshare, {{userType}} can change quickshare preferences",
              { userType: isCompanyAdmin ? t('you') : t('your admin') }
            )}
            {isCompanyAdmin && (
              <>
                <span> {t('under')}</span>
                <span
                  style={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    marginLeft: '4px',
                  }}
                  onClick={goToCompanySettings}
                >
                  {t('My Company settings.')}
                </span>
              </>
            )}
          </Text>
        </Disclaimer>
      </BlueBox>
      <ButtonsWrapper>
        <Button
          text={t("Leave as 'Not Sent'")}
          variant='white'
          disabled={isQuickShareLoading}
          onClick={() => {
            quickShareMarkAsSentHandler({
              markAsSentConfirmed: false,
              ...markAsSentPayload,
            });
          }}
        />
        <Button
          text={t('Mark as Sent')}
          variant='primary'
          disabled={isQuickShareLoading}
          onClick={() => {
            quickShareMarkAsSentHandler({
              markAsSentConfirmed: true,
              ...markAsSentPayload,
            });
          }}
        />
      </ButtonsWrapper>
    </NewModal>
  );
};
